import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { NaturalezaJuridica } from './naturalezas-juridica.model';

export const entityNaturalezaJuridicaAdapter: EntityAdapter<NaturalezaJuridica> =
  createEntityAdapter<NaturalezaJuridica>({
    selectId: (model) => model.id,
    sortComparer: (a: NaturalezaJuridica, b: NaturalezaJuridica): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityNaturalezaJuridicaState
  extends EntityState<NaturalezaJuridica> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityNaturalezaJuridicaState =
  entityNaturalezaJuridicaAdapter.getInitialState({
    isLoading: false,
    error: null
  });
